export type ThemePreference = "light" | "dark" | "system";
const STORAGE_KEY = "b2a_theme";
const listeners = new Set<() => void>();
let preference: ThemePreference = "system";
let started = false;
let system: MediaQueryList | undefined;

function parse(value: string | null): ThemePreference {
  return value === "light" || value === "dark" ? value : "system";
}

function apply() {
  const resolved = preference === "system" ? (system?.matches ? "dark" : "light") : preference;
  document.documentElement.dataset.theme = resolved;
  document.documentElement.style.colorScheme = resolved;
  document.documentElement.dataset.themePreference = preference;
  for (const listener of listeners) listener();
}

export function initializeTheme() {
  if (started || typeof window === "undefined") return;
  started = true;
  try {
    preference = parse(window.localStorage.getItem(STORAGE_KEY));
  } catch {
    // Storage can be unavailable in private or restricted contexts.
  }
  system = window.matchMedia?.("(prefers-color-scheme: dark)");
  system?.addEventListener("change", apply);
  window.addEventListener("storage", (event) => {
    if (event.key !== STORAGE_KEY && event.key !== null) return;
    preference = parse(event.newValue);
    apply();
  });
  apply();
}

export function getThemePreference(): ThemePreference {
  initializeTheme();
  return preference;
}

export function setThemePreference(value: ThemePreference) {
  initializeTheme();
  preference = value;
  try {
    window.localStorage.setItem(STORAGE_KEY, value);
  } catch {
    // The current session still follows the choice when persistence is blocked.
  }
  apply();
}

export function subscribeTheme(listener: () => void) {
  initializeTheme();
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
